// source: xcommon/enum.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.xcommon.AttendanceStatus', null, global);
goog.exportSymbol('proto.xcommon.CaseType', null, global);
goog.exportSymbol('proto.xcommon.DataPermKind', null, global);
goog.exportSymbol('proto.xcommon.Decision', null, global);
goog.exportSymbol('proto.xcommon.EmployeeLabel', null, global);
goog.exportSymbol('proto.xcommon.ExecType', null, global);
goog.exportSymbol('proto.xcommon.FrozenInterestType', null, global);
goog.exportSymbol('proto.xcommon.GroupType', null, global);
goog.exportSymbol('proto.xcommon.LoginStatus', null, global);
goog.exportSymbol('proto.xcommon.ManMachineCollaborationNotify', null, global);
goog.exportSymbol('proto.xcommon.Mark', null, global);
goog.exportSymbol('proto.xcommon.NotifyBusinessType', null, global);
goog.exportSymbol('proto.xcommon.OutSourceRange', null, global);
goog.exportSymbol('proto.xcommon.PayrollCycleKind', null, global);
goog.exportSymbol('proto.xcommon.PermType', null, global);
goog.exportSymbol('proto.xcommon.PhoneObjectEnum', null, global);
goog.exportSymbol('proto.xcommon.PushTargetEnum', null, global);
goog.exportSymbol('proto.xcommon.PushTaskTypeEnum', null, global);
goog.exportSymbol('proto.xcommon.ReportStatus', null, global);
goog.exportSymbol('proto.xcommon.SchemaModeEnum', null, global);
goog.exportSymbol('proto.xcommon.SettleType', null, global);
goog.exportSymbol('proto.xcommon.Status', null, global);
goog.exportSymbol('proto.xcommon.StatusTypeEnum', null, global);
goog.exportSymbol('proto.xcommon.StuffLabel', null, global);
goog.exportSymbol('proto.xcommon.TaskStatusEnum', null, global);
goog.exportSymbol('proto.xcommon.TwoFactAuthRange', null, global);
goog.exportSymbol('proto.xcommon.UserStatus', null, global);
goog.exportSymbol('proto.xcommon.UserStatusRange', null, global);
goog.exportSymbol('proto.xcommon.UserType', null, global);
goog.exportSymbol('proto.xcommon.UserWorkStatus', null, global);
goog.exportSymbol('proto.xcommon.UserWorkStatusRange', null, global);
goog.exportSymbol('proto.xcommon.VerifyAction', null, global);
goog.exportSymbol('proto.xcommon.YNType', null, global);
/**
 * @enum {number}
 */
proto.xcommon.Decision = {
  DECISION_ALLOW: 0,
  DECISION_DENY: 1
};

/**
 * @enum {number}
 */
proto.xcommon.Mark = {
  MARK_UNSPECIFIED: 0,
  MARK_ON: 1,
  MARK_OFF: 2
};

/**
 * @enum {number}
 */
proto.xcommon.Status = {
  STATUS_UNSPECIFIED: 0,
  STATUS_NORMAL: 1,
  STATUS_ABNORMAL: 2
};

/**
 * @enum {number}
 */
proto.xcommon.ExecType = {
  EXEC_TYPE_UNSPECIFIED: 0,
  EXEC_TYPE_URGE_INTERNAL: 1,
  EXEC_TYPE_URGE_OUTSOURCE: 2,
  EXEC_TYPE_TEL_VERIFY: 3,
  EXEC_TYPE_ROBOT: 4,
  EXEC_TYPE_TEMP: 5,
  EXEC_TYPE_ADMIN: 6,
  EXEC_TYPE_PHONE_SALE: 7
};

/**
 * @enum {number}
 */
proto.xcommon.LoginStatus = {
  LOGIN_STATUS_UNSPECIFIED: 0,
  LOGIN_STATUS_ONLINE: 1,
  LOGIN_STATUS_OFFLINE: 2
};

/**
 * @enum {number}
 */
proto.xcommon.DataPermKind = {
  DATA_PERM_KIND_UNSPECIFIED: 0,
  DATA_PERM_KIND_PERSONAL: 1,
  DATA_PERM_KIND_GROUP: 2
};

/**
 * @enum {number}
 */
proto.xcommon.PayrollCycleKind = {
  PAYROLL_CYCLE_KIND_UNSPECIFIED: 0,
  PAYROLL_CYCLE_KIND_CURRENT_PERIOD: 1,
  PAYROLL_CYCLE_KIND_LAST_PERIOD: 2,
  PAYROLL_CYCLE_KIND_CURRENT_MONTH: 3
};

/**
 * @enum {number}
 */
proto.xcommon.StuffLabel = {
  STUFF_LABEL_UNSPECIFIED: 0,
  STUFF_LABEL_NEW_EMPLOYEE: 1,
  STUFF_LABEL_VETERAN_EMPLOYEE: 2
};

/**
 * @enum {number}
 */
proto.xcommon.UserType = {
  USER_TYPE_UNSPECIFIED: 0,
  USER_TYPE_URGE: 1,
  USER_TYPE_CALL_VERIFY: 2
};

/**
 * @enum {number}
 */
proto.xcommon.AttendanceStatus = {
  ATTENDANCE_STATUS_UNSPECIFIED: 0,
  ATTENDANCE_STATUS_ATTEND: 1,
  ATTENDANCE_STATUS_ABSENT: 2,
  ATTENDANCE_STATUS_LATE: 3
};

/**
 * @enum {number}
 */
proto.xcommon.UserStatus = {
  USER_STATUS_UNSPECIFIED: 0,
  USER_STATUS_NORMAL: 1,
  USER_STATUS_BANED: 2,
  USER_STATUS_INVALID: 3
};

/**
 * @enum {number}
 */
proto.xcommon.UserWorkStatus = {
  USER_WORK_STATUS_UNSPECIFIED: 0,
  USER_WORK_STATUS_TAKING_ORDERS: 1,
  USER_WORK_STATUS_STOP_TAKING_ORDERS: 2
};

/**
 * @enum {number}
 */
proto.xcommon.TwoFactAuthRange = {
  TWO_FACT_AUTH_RANGE_UNSPECIFIED: 0,
  TWO_FACT_AUTH_RANGE_DISABLE: 2,
  TWO_FACT_AUTH_RANGE_ENABLE: 1,
  TWO_FACT_AUTH_RANGE_ALL: 3
};

/**
 * @enum {number}
 */
proto.xcommon.OutSourceRange = {
  OUT_SOURCE_RANGE_UNSPECIFIED: 0,
  OUT_SOURCE_RANGE_ALL: 1,
  OUT_SOURCE_RANGE_INNER: 2,
  OUT_SOURCE_RANGE_OUT_SOURCE: 3,
  OUT_SOURCE_RANGE_TEL_VERIFY: 4,
  OUT_SOURCE_RANGE_ROBOT: 5,
  OUT_SOURCE_RANGE_TEMP: 6,
  OUT_SOURCE_RANGE_ADMIN: 7,
  OUT_SOURCE_RANGE_PHONE_SALE: 8
};

/**
 * @enum {number}
 */
proto.xcommon.UserStatusRange = {
  USER_STATUS_RANGE_UNSPECIFIED: 0,
  USER_STATUS_RANGE_NORMAL: 1,
  USER_STATUS_RANGE_BANED: 2,
  USER_STATUS_RANGE_INVALID: 3,
  USER_STATUS_RANGE_ALL: 4
};

/**
 * @enum {number}
 */
proto.xcommon.UserWorkStatusRange = {
  USER_WORK_STATUS_RANGE_UNSPECIFIED: 0,
  USER_WORK_STATUS_RANGE_ALL: 1,
  USER_WORK_STATUS_RANGE_TAKING_ORDERS: 2,
  USER_WORK_STATUS_RANGE_STOP_TAKING_ORDERS: 3
};

/**
 * @enum {number}
 */
proto.xcommon.CaseType = {
  CASE_TYPE_UNSPECIFIED: 0,
  CASE_TYPE_REMIND: 1,
  CASE_TYPE_URGE: 2,
  CASE_TYPE_ALL: 3
};

/**
 * @enum {number}
 */
proto.xcommon.GroupType = {
  GROUP_TYPE_UNSPECIFIED: 0,
  GROUP_TYPE_NORMAL: 1,
  GROUP_TYPE_SWAT: 2,
  GROUP_TYPE_ALL: 3
};

/**
 * @enum {number}
 */
proto.xcommon.SettleType = {
  SETTLE_TYPE_UNSPECIFIED: 0,
  SETTLE_TYPE_BY_RANGE: 1,
  SETTLE_TYPE_BY_DAY: 2,
  SETTLE_TYPE_ALL: 3
};

/**
 * @enum {number}
 */
proto.xcommon.EmployeeLabel = {
  EMPLOYEE_LABEL_UNSPECIFIED: 0,
  EMPLOYEE_LABEL_FIVE: 1,
  EMPLOYEE_LABEL_SEVEN: 2,
  EMPLOYEE_LABEL_ALL: 3
};

/**
 * @enum {number}
 */
proto.xcommon.PermType = {
  PERM_TYPE_UNSPECIFIED: 0,
  PERM_TYPE_MENU: 1,
  PERM_TYPE_BUTTON: 2
};

/**
 * @enum {number}
 */
proto.xcommon.YNType = {
  YN_ALL: 0,
  YN_Y: 1,
  YN_N: 2
};

/**
 * @enum {number}
 */
proto.xcommon.StatusTypeEnum = {
  ST_ALL: 0,
  ST_VALID: 1,
  ST_INVALID: 2
};

/**
 * @enum {number}
 */
proto.xcommon.PushTaskTypeEnum = {
  PT_UNSPECIFIED: 0,
  PT_SMS: 1,
  PT_PUSH: 2,
  PT_WHATSAPP: 3
};

/**
 * @enum {number}
 */
proto.xcommon.ReportStatus = {
  REPORT_STATUS_UNSPECIFIED: 0,
  REPORT_STATUS_WAIT_THIRD_VERIFY: 1,
  REPORT_STATUS_CAN_UPDATE: 2,
  REPORT_STATUS_WAIT_CS_DEAL: 3
};

/**
 * @enum {number}
 */
proto.xcommon.FrozenInterestType = {
  FROZENINTEREST_UNSPECIFIED: 0,
  FROZENINTEREST_READY: 1,
  FROZENINTEREST_ZOMBIES: 2,
  FROZENINTEREST_ONGOING: 3
};

/**
 * @enum {number}
 */
proto.xcommon.VerifyAction = {
  VA_UNSPECIFIED: 0,
  VA_VALID: 1,
  VA_INVALID: 2,
  VA_REFUSED: 3,
  VA_NOTHING: 10
};

/**
 * @enum {number}
 */
proto.xcommon.TaskStatusEnum = {
  TSE_UNSPECIFIED: 0,
  TSE_ON: 1,
  TSE_OFF: 2,
  TSE_ERROR: 3,
  TSE_RUNNING: 4
};

/**
 * @enum {number}
 */
proto.xcommon.PushTargetEnum = {
  PTE_UNSPECIFIED: 0,
  PTE_OVERDUE: 1
};

/**
 * @enum {number}
 */
proto.xcommon.PhoneObjectEnum = {
  PO_UNSPECIFIED: 0,
  PO_SELF: 1,
  PO_CONTACT1: 2,
  PO_CONTACT2: 3,
  PO_CONTACT3: 4
};

/**
 * @enum {number}
 */
proto.xcommon.SchemaModeEnum = {
  SME_UNSPECIFIED: 0,
  SME_MANUAL: 1,
  SME_AUTO: 2,
  SME_BUSINESS: 3
};

/**
 * @enum {number}
 */
proto.xcommon.NotifyBusinessType = {
  NOTIFYBUSINESS_UNSPECIFIED: 0,
  NOTIFYBUSINESS_MANMACHINECOLLABORATION: 1
};

/**
 * @enum {number}
 */
proto.xcommon.ManMachineCollaborationNotify = {
  MANMACHINECOLLABORATION_UNSPECIFIED: 0,
  MANMACHINECOLLABORATION_START: 1,
  MANMACHINECOLLABORATION_LATER: 2,
  MANMACHINECOLLABORATION_CATCHUNTREATEDTICKET: 3
};

module.exports = proto.xcommon;
